module.exports = __webpack_public_path__ + "img/card-badge-rivoneed.cea40207.webp";